// = Libs =
import React, { FC, forwardRef, LegacyRef, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import moment from 'moment';
import clsx from 'clsx';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';

// = Styles =
import classes from './date.module.scss';
import 'react-datepicker/dist/react-datepicker.css';

// = Types =
import { DateProps } from './date.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

registerLocale('ru', ru);

const CustomDatePicker: FC<DateProps> = (props) => {
  const {
    value,
    placeholder = '',
    className = '',
    name = '',
    required = false,
    fullWidth = false,
    onChange,
    onBlur,
    disabled = false,
  } = props;

  const [date, setDate] = useState<Date | null>(null);

  useEffect(() => {
    if (!value) return setDate(null);

    const newValue = moment(value).toDate();
    setDate(newValue);
  }, [value]);

  const CustomInput = forwardRef(
    (props: React.HTMLProps<HTMLInputElement>, ref: LegacyRef<InputMask>) => {
      return (
        <>
          <InputMask
            {...props}
            disabled={disabled}
            ref={ref}
            className={classes.date__field}
            mask="99.99.9999"
          />

          {placeholder && (
            <span
              className={clsx({
                [classes['date__placeholder']]: true,
                [classes['date__placeholder--focus']]: value,
              })}>
              {placeholder}
            </span>
          )}
        </>
      );
    }
  );

  const handleChange = (date: Date) => {
    setDate(date);

    onChange && onChange(date.toISOString());
  };

  return (
    <div
      className={clsx(
        {
          [classes.date]: true,
          [classes['date--full-width']]: fullWidth,
        },
        className
      )}>
      <DatePicker
        wrapperClassName={classes.date__field__datePicker}
        selected={date}
        name={name}
        locale="ru"
        onChange={handleChange}
        dateFormat="dd.MM.yyyy"
        customInput={<CustomInput />}
        onBlur={onBlur}
      />

      <span className={classes.date__icon}>
        <Icon type="calendar" color="primary" />
      </span>
    </div>
  );
};

export default CustomDatePicker;
